module.exports = __webpack_public_path__ + "assets/img/WatchBAPC.b7dec5a5.png";